import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from './ui/Countdown';
export function CountdownUrgency() {
  return <section className="py-12 bg-[#d4af37] text-[#1a3622] border-y-4 border-[#8b5a2b]" data-id="element-32">
      <div className="container mx-auto px-4 text-center" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto" data-id="element-34">
          <h2 className="text-2xl md:text-3xl font-black uppercase tracking-wider mb-6 text-[#1a3622]" data-id="element-35">
            ⏰ El precio de lanzamiento termina pronto
          </h2>

          <div className="mb-8" data-id="element-36">
            <Countdown initialHours={23} initialMinutes={58} initialSeconds={50} theme="dark" className="shadow-2xl scale-110 md:scale-125 origin-center bg-[#1a3622] text-white border-[#2c4c3b]" data-id="element-37" />
          </div>

          <p className="text-xl font-bold text-[#5c4033] mb-8" data-id="element-38">
            ⚠️ Después sube — y no vuelve a bajar.
          </p>

          <div className="bg-white/50 rounded-xl p-6 max-w-xl mx-auto border border-[#8b5a2b]/30" data-id="element-39">
            <p className="font-bold mb-3 flex items-center justify-center gap-2 text-[#1a3622]" data-id="element-40">
              <span className="w-3 h-3 rounded-full bg-[#1a3622] animate-pulse" data-id="element-41"></span>
              Quedan pocos cupos al precio de lanzamiento
            </p>

            <div className="w-full bg-[#1a3622]/20 rounded-full h-4 mb-2 overflow-hidden border border-[#1a3622]/30" data-id="element-42">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '85%'
            }} transition={{
              duration: 1.5,
              ease: 'easeOut'
            }} className="bg-[#1a3622] h-4 rounded-full" data-id="element-43"></motion.div>
            </div>
            <p className="text-sm text-[#5c4033] font-medium text-right" data-id="element-44">
              85% de los cupos tomados
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}